<template lang='pug'>
section
  s-page-title(title='Шаги договора')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    v-data-table(
      v-sortable=`{
        handler: '.sort-handle',
        container: 'tbody',
        callback: onOrderChange
      }`
      :loading='isLoading'
      :headers='headers'
      :items='list'
      hide-actions
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item.id)')
          td(data-label='ID') {{ props.item.id }}
          td(data-label='Название') {{ props.item.name }}
          td(data-label='Алиас') {{ props.item.alias }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item.id)')
              v-icon(small) delete_outline
            v-btn(icon class='sort-handle')
              v-icon drag_handle
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        sortable: false
      },
      {
        text: 'Название',
        width: '50%',
        sortable: false
      },
      {
        text: 'Алиас',
        width: '50%',
        sortable: false
      },
      {
        text: '',
        sortable: false
      }
    ]
  }),

  created() {
    this.fetchList()
  },

  methods: {
    async onDelete(id) {
      if (!this.isLoading && (await this.$confirm('Удалить шаг?'))) {
        try {
          await this.destroy({ id })
        } catch (e) {
          this.$root.showSnack('Ошибка удаления шага')
        }

        this.fetchList()
      }
    },

    async onOrderChange({ oldIndex, newIndex }) {
      let movedItem = this.list.splice(oldIndex, 1)[0]
      this.list.splice(newIndex, 0, movedItem)

      try {
        await this.sortList(this.list.map(x => x.id))
      } catch (e) {
        this.$root.showSnack('Ошибка сортировки')
      }
    },

    onEdit(id) {
      this.$router.push({
        name: 'Admin.Steps.Edit',
        params: { id }
      })
    },

    ...mapActions('admin/steps', ['fetchList', 'destroy', 'sortList'])
  },

  computed: {
    ...mapGetters('admin/steps', ['list', 'isLoading'])
  }
}
</script>
